import { render, staticRenderFns } from "./FormPartSourceOfFunds.vue?vue&type=template&id=78a0dca4&scoped=true"
import script from "./FormPartSourceOfFunds.vue?vue&type=script&lang=js"
export * from "./FormPartSourceOfFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a0dca4",
  null
  
)

export default component.exports